/**
 * Shared custom event names emitted and consumed across gallery components.
 */
export interface PreviewLoadErrorEventDetail {
  id: string
}

export class GalleryEvent {
  static readonly VIEW_MODE_CHANGE = 'view-mode-change'

  static readonly FILE_OPEN = 'file-open'

  static readonly FILE_SELECT = 'file-select'

  static readonly SELECT_ALL_TOGGLE = 'select-all-toggle'

  static readonly DETAIL_CLOSE = 'detail-close'

  static readonly DETAIL_PREV = 'detail-prev'

  static readonly DETAIL_NEXT = 'detail-next'

  static readonly DOWNLOAD_REQUEST = 'download-request'

  static readonly PREVIEW_LOAD_ERROR = 'preview-load-error'
}
